"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = _interopRequireDefault(require("D:\\\u9879\u76EE\u7BA1\u7406\\\u65E7\u6362\u65B0\\\u6E90\u7801\\yijiuhuanxin_project_java\\WebPcAdmin\\node_modules\\@babel\\runtime\\regenerator\\index.js"));

var _sms = require("@/api/sms");

var commFilter = _interopRequireWildcard(require("@/filters/commFilter"));

var _index2 = _interopRequireDefault(require("../../../appSetting/wxAccount/wxTemplate/index"));

var _permission = require("@/utils/permission");

var _validate = require("@/utils/validate");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var _default = {
  name: 'TableList',
  props: {
    copy: {
      type: Object,
      default: null
    },
    dump: {
      type: Object,
      default: null
    },
    query: {
      type: Object,
      default: null
    },
    sms: {
      type: Object,
      default: null
    },
    accountInfo: {
      type: Object,
      default: null
    }
  },
  components: {
    Template: _index2.default
  },
  data: function data() {
    var validatePhone = function validatePhone(rule, value, callback) {
      if (!value) {
        return callback(new Error('请填写手机号'));
      } else if (!/^1[3456789]\d{9}$/.test(value)) {
        callback(new Error('手机号格式不正确!'));
      } else {
        callback();
      }
    };

    return {
      dialogVisible: false,
      listLoading: false,
      tableData: {
        data: [],
        total: 0
      },
      tableFrom: {
        page: 1,
        limit: 20,
        status: '3',
        type: 'sms'
      },
      columns2: [],
      isSms: false,
      // 是否开通短信
      isDump: false,
      // 是否开通电子面单,是否开通物流查询
      isCopy: false,
      // 是否开通商品采集
      modals: false,
      loading: false,
      formInlineDump: {
        tempId: '',
        sign: '',
        com: '',
        toName: '',
        toTel: '',
        siid: '',
        toAddress: '',
        type: ''
      },
      ruleInline: {
        sign: [{
          required: true,
          message: '请输入短信签名',
          trigger: 'blur'
        }],
        phone: [{
          required: true,
          validator: validatePhone,
          trigger: 'blur'
        }],
        code: [{
          required: true,
          message: '请输入验证码',
          trigger: 'blur'
        }],
        com: [{
          required: true,
          message: '请选择快递公司',
          trigger: 'change'
        }],
        tempId: [{
          required: true,
          message: '请选择打印模板',
          trigger: 'change'
        }],
        toName: [{
          required: true,
          message: '请输寄件人姓名',
          trigger: 'blur'
        }],
        toTel: [{
          required: true,
          validator: validatePhone,
          trigger: 'blur'
        }],
        siid: [{
          required: true,
          message: '请输入云打印机编号',
          trigger: 'blur'
        }],
        toAddress: [{
          required: true,
          message: '请输寄件人地址',
          trigger: 'blur'
        }]
      },
      tempImg: '',
      // 图片
      exportTempList: [],
      // 电子面单模板
      exportList: [],
      // 快递公司列表
      formInline: {
        phone: '',
        code: '',
        sign: ''
      },
      ruleInlineSign: {
        sign: [{
          required: true,
          message: '请输入短信签名',
          trigger: 'blur'
        }],
        phone: [{
          required: true,
          validator: validatePhone,
          trigger: 'blur'
        }],
        code: [{
          required: true,
          message: '请输入验证码',
          trigger: 'blur'
        }]
      },
      cutNUm: '获取验证码',
      canClick: true
    };
  },
  watch: {
    sms: function sms(n) {
      if (n.open === 1) this.getList();
    }
  },
  mounted: function mounted() {
    if (this.sms.open === 1) this.getList(); // if (this.isChecked === '1' && this.sms.open === 1) this.getList();
  },
  methods: {
    editSign: function editSign() {
      this.formInline.account = this.accountInfo.account;
      this.formInline.sign = this.accountInfo.sms.sign;
      this.formInline.phone = this.accountInfo.phone;
      this.dialogVisible = true;
    },
    //修改签名
    handleSubmit: (0, _validate.Debounce)(function (name) {
      var _this = this;

      this.$refs[name].validate(function (valid) {
        if (valid) {
          (0, _sms.smsSignApi)(_this.formInline).then( /*#__PURE__*/function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/_index.default.mark(function _callee(res) {
              return _index.default.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      _this.$message.success('修改签名之后一号通需要审核过后通过!');

                      _this.dialogVisible = false;

                      _this.$refs[formName].resetFields();

                    case 3:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _callee);
            }));

            return function (_x) {
              return _ref.apply(this, arguments);
            };
          }());
        } else {
          return false;
        }
      });
    }),
    // 短信验证码
    cutDown: function cutDown() {
      var _this2 = this;

      if (this.formInline.phone) {
        if (!this.canClick) return;
        this.canClick = false;
        this.cutNUm = 60;
        var data = {
          phone: this.formInline.phone,
          types: 1
        };
        (0, _sms.captchaApi)(data).then( /*#__PURE__*/function () {
          var _ref2 = _asyncToGenerator( /*#__PURE__*/_index.default.mark(function _callee2(res) {
            return _index.default.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    _this2.$message.success(res.msg);

                  case 1:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2);
          }));

          return function (_x2) {
            return _ref2.apply(this, arguments);
          };
        }());
        var time = setInterval(function () {
          _this2.cutNUm--;

          if (_this2.cutNUm === 0) {
            _this2.cutNUm = '获取验证码';
            _this2.canClick = true;
            clearInterval(time);
          }
        }, 1000);
      } else {
        this.$message.warning('请填写手机号!');
      }
    },
    handleClose: function handleClose() {
      this.dialogVisible = false;
      this.$refs['formInline'].resetFields();
    },
    // 首页去开通
    onOpenIndex: function onOpenIndex(val) {
      this.tableFrom.type = val;

      switch (val) {
        case 'sms':
          this.isSms = true;
          break;

        case 'expr_dump':
          this.openDump();
          break;

        default:
          this.openOther();
          break;
      }
    },
    // 开通其他
    openOther: function openOther() {
      var _this3 = this;

      this.$confirm("\u786E\u5B9A\u5F00\u901A".concat(commFilter.onePassTypeFilter(this.tableFrom.type), "\u5417?"), '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        // this.handleSubmitDump('formInlineDump');
        (0, _sms.serviceOpenApi)({
          type: _this3.tableFrom.type
        }).then( /*#__PURE__*/function () {
          var _ref3 = _asyncToGenerator( /*#__PURE__*/_index.default.mark(function _callee3(res) {
            return _index.default.wrap(function _callee3$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    _this3.$message.success('开通成功!');

                    _this3.getList();

                    _this3.$emit('openService');

                  case 3:
                  case "end":
                    return _context3.stop();
                }
              }
            }, _callee3);
          }));

          return function (_x3) {
            return _ref3.apply(this, arguments);
          };
        }());
      }).catch(function () {
        _this3.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    // 开通电子面单
    openDump: function openDump() {
      this.exportTempAllList();
      this.isDump = true;
    },
    // 物流公司
    exportTempAllList: function exportTempAllList() {
      var _this4 = this;

      (0, _sms.expressAllApi)({
        type: 'elec'
      }).then( /*#__PURE__*/function () {
        var _ref4 = _asyncToGenerator( /*#__PURE__*/_index.default.mark(function _callee4(res) {
          return _index.default.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  _this4.exportList = res;

                case 1:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4);
        }));

        return function (_x4) {
          return _ref4.apply(this, arguments);
        };
      }());
    },
    // 快递公司选择
    onChangeExport: function onChangeExport(val) {
      this.formInlineDump.tempId = '';
      this.exportTemp(val);
    },
    // 电子面单模板
    exportTemp: function exportTemp(val) {
      var _this5 = this;

      (0, _sms.exportTempApi)({
        com: val
      }).then( /*#__PURE__*/function () {
        var _ref5 = _asyncToGenerator( /*#__PURE__*/_index.default.mark(function _callee5(res) {
          return _index.default.wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  _this5.exportTempList = res.data.data || [];

                case 1:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5);
        }));

        return function (_x5) {
          return _ref5.apply(this, arguments);
        };
      }());
    },
    onChangeImg: function onChangeImg(item) {
      var _this6 = this;

      this.exportTempList.map(function (i) {
        if (i.temp_id === item) _this6.tempImg = i.pic;
      });
    },
    handleSubmitDump: function handleSubmitDump(name) {
      var _this7 = this;

      this.formInlineDump.type = this.tableFrom.type;
      this.$refs[name].validate(function (valid) {
        if (valid) {
          _this7.loading = true;
          (0, _sms.serviceOpenApi)(_this7.formInlineDump).then( /*#__PURE__*/function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/_index.default.mark(function _callee6(res) {
              return _index.default.wrap(function _callee6$(_context6) {
                while (1) {
                  switch (_context6.prev = _context6.next) {
                    case 0:
                      _this7.$emit('openService');

                      _this7.$message.success('开通成功!');

                      _this7.getList();

                      _this7.loading = false;

                    case 4:
                    case "end":
                      return _context6.stop();
                  }
                }
              }, _callee6);
            }));

            return function (_x6) {
              return _ref6.apply(this, arguments);
            };
          }()).catch(function () {
            _this7.loading = false;
          });
        } else {
          return false;
        }
      });
    },
    onChangeType: function onChangeType() {
      this.tableFrom.page = 1;
      this.getList();
    },
    // 列表
    getList: function getList() {
      var _this8 = this;

      this.listLoading = true;
      (0, _sms.smsLstApi)(this.tableFrom).then(function (res) {
        _this8.tableData.data = res.data;

        if (_this8.tableFrom.type == 'sms') {
          var obj = new Object();
          var newArr = new Array();
          res.data.forEach(function (item) {
            obj = item;

            switch (item.status) {
              case 0:
                obj.status = '发送中';
                break;

              case 1:
                obj.status = '成功';
                break;

              case 2:
                obj.status = '失败';
                break;

              case 3:
                obj.status = '全部';
                break;
            }

            newArr.push(obj);
            _this8.tableData.data = newArr;
          });
        }

        _this8.tableData.total = res.count;

        switch (_this8.tableFrom.type) {
          case 'sms':
            _this8.columns2 = [{
              title: '手机号',
              key: 'phone',
              minWidth: 100
            }, {
              title: '模板内容',
              key: 'content',
              minWidth: 590
            }, {
              title: '发送时间',
              key: 'add_time',
              minWidth: 150
            } // {
            //   title: '状态',
            //   key: 'status',
            //   minWidth: 100
            // }
            ];
            break;

          case 'expr_dump':
            _this8.columns2 = [// {
            //   title: '订单号',
            //   key: 'order_id',
            //   minWidth: 150
            // },
            {
              title: '发货人',
              key: 'from_name',
              minWidth: 120
            }, {
              title: '收货人',
              key: 'to_name',
              minWidth: 120
            }, {
              title: '快递单号',
              key: 'num',
              minWidth: 120
            }, {
              title: '快递公司编码',
              key: 'code',
              minWidth: 120
            }, {
              title: '状态',
              key: '_resultcode',
              minWidth: 100
            }, {
              title: '打印时间',
              key: 'add_time',
              minWidth: 150
            }];
            break;

          case 'expr_query':
            _this8.columns2 = [{
              title: '快递单号',
              key: 'content',
              minWidth: 120
            }, {
              title: '快递公司编码',
              key: 'code',
              minWidth: 120
            }, {
              title: '状态',
              key: '_resultcode',
              minWidth: 120
            }, {
              title: '添加时间',
              key: 'add_time',
              minWidth: 150
            }];
            break;

          default:
            _this8.columns2 = [{
              title: '复制URL',
              key: 'url',
              minWidth: 400
            }, {
              title: '请求状态',
              key: '_resultcode',
              minWidth: 120
            }, {
              title: '添加时间',
              key: 'add_time',
              minWidth: 150
            }];
            break;
        }

        _this8.listLoading = false;
      }).catch(function (res) {
        _this8.listLoading = false;
      });
    },
    pageChange: function pageChange(page) {
      this.tableFrom.page = page;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.tableFrom.limit = val;
      this.getList();
    }
  }
};
exports.default = _default;